module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-proveedores/catalogo-proveedores.component.scss
// module id = ./src/app/components/catalogo-proveedores/catalogo-proveedores.component.scss
// module chunks = main